import { ArrayInput, TextField } from "react-admin";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";
import { ListIterator } from "../../common/list/compact-list/ListIterator";
import resourceNames from "../../../common/data/resourceNames";
import { useForm } from "react-final-form";
import {
  DriverViewListDto,
  RecordStatus,
  VirtualTenantApiFactory,
  VirtualTenantVehicleRangeDto,
} from "../../../common/data/service-proxies";
import { useAxiosInstance } from "../../../common/hooks/useAxiosInstance";
import { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";

interface Props {
  isPeriodEnabled?: boolean;
}

const useStyles = makeStyles((theme) => ({
  "form-wrapper": {
    display: "flex",
    flexFlow: "row-reverse",
    gap: "8px",
  },
  "auto-selected-drivers": {
    marginTop: "16px",
    marginBottom: "8px",
    flexGrow: 1,
  },
}));

export const DriverSelectionGrid = ({ isPeriodEnabled = false, ...props }: Props) => {
  const classes = useStyles();
  const form = useForm();
  const tenantIdState = form.getFieldState("tenantId");
  const vehicleIdsState = form.getFieldState(isPeriodEnabled ? "vehicles" : "vehicleIds");
  const axiosInstance = useAxiosInstance();
  const [autoSelectedDrivers, setAutoSelectedDrivers] = useState<
    DriverViewListDto[]
  >();

  useEffect(() => {
    if (!axiosInstance) {
      return;
    }

    if (!tenantIdState?.value) {
      return;
    }

    if (!vehicleIdsState?.value) {
      return;
    }

    VirtualTenantApiFactory(
      undefined,
      axiosInstance.defaults.baseURL,
      axiosInstance
    )
      .apiAppVirtualtenantGetvehicledriversPost({
        tenantId: tenantIdState?.value,
        vehicleIds: isPeriodEnabled ? vehicleIdsState?.value.map((x: VirtualTenantVehicleRangeDto) => x.vehicleId) : vehicleIdsState?.value,
      })
      .then((x) => {
        setAutoSelectedDrivers(x.data);
      });
  }, [axiosInstance, tenantIdState, vehicleIdsState, isPeriodEnabled]);

  return tenantIdState?.value ? (
    <div className={classes["form-wrapper"]}>
      {autoSelectedDrivers ? (
        <Card className={classes["auto-selected-drivers"]}>
          <CardHeader
            title="The following drivers will be visible regardless of the selection:"
            titleTypographyProps={{ variant: "body2" }}
          ></CardHeader>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography variant="body1">ID</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body1">Name</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {autoSelectedDrivers.map((x) => (
                <TableRow key={x.id}>
                  <TableCell>{x.driverId}</TableCell>
                  <TableCell>{x.driverName}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      ) : null}
      <ProtectedElement source="driverIds" label="" {...props}>
        <ArrayInput source="driverIds">
          <ListIterator
            reference={resourceNames.ADMIN_DRIVERS_VIEW}
            sort={{ field: "driverName", order: "asc" }}
            filter={{
              tenantId: tenantIdState?.value,
              status: RecordStatus.Active,
            }}
          >
            <TextField source="driverId" label="ID" />
            <TextField
              source="driverName"
              label="resources.admin-drivers.labels.displayName"
            />
          </ListIterator>
        </ArrayInput>
      </ProtectedElement>
    </div>
  ) : null;
};
